angular.module("vgresiduos").controller("MasterPermissionGroupEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/perfil-acesso/${$stateParams.id}`);
		};
	}
]);
